import React, { useState, useEffect } from "react";
import SuccessToast from "../components/SuccessToast/SuccessToast";

export function useSuccessToast(defaultState = "") {
  const [successMsg, setSuccessMsg] = useState(defaultState);

  useEffect(() => {
    if (successMsg) {
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  }, [successMsg]);

  const successToast = successMsg && (
    <SuccessToast close={() => setSuccessMsg("")}>{successMsg}</SuccessToast>
  );

  return {
    successMsg,
    setSuccessMsg,
    successToast,
  };
}
